import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { api } from "../lib/api";

export default function PreviewPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/preview/${token}`)
      .then(({ data }) => setData(data))
      .catch(() => setMissing(true));
  }, [token]);

  if (missing) {
    return (
      <div className="min-h-screen bg-[#070709] flex flex-col items-center justify-center gap-6" data-testid="preview-not-found">
        <p className="font-serif text-3xl text-[#ede8e1]">This preview seal is broken.</p>
        <Link to="/" className="font-mono text-xs tracking-[0.25em] uppercase text-[#581313]">Return to the Vault</Link>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen bg-[#070709] flex items-center justify-center">
        <p className="font-mono text-xs tracking-[0.4em] uppercase text-[#78716c] flicker">Unsealing…</p>
      </div>
    );
  }

  const { post, section } = data;

  return (
    <div className="relative min-h-screen bg-[#070709]" data-testid="preview-page">
      <div className="sticky top-0 z-50 border-b border-[#581313]/60 bg-[rgba(88,19,19,0.15)] backdrop-blur-xl" data-testid="preview-banner">
        <p className="max-w-7xl mx-auto px-4 sm:px-6 py-3 font-mono text-[11px] tracking-[0.3em] uppercase text-[#ede8e1]">
          Draft preview — unseen by the public — {post.status}
        </p>
      </div>
      <main className="relative z-10 pt-20 pb-24">
        <article className="max-w-3xl mx-auto px-4 sm:px-6">
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-[#581313] mb-5">
            {section?.title} — {new Date(post.created_at).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })}
          </p>
          <h1 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-[#ede8e1]" data-testid="preview-title">
            {post.title}
          </h1>
          {post.excerpt && <p className="mt-5 text-lg italic font-light text-[#a8a29e]">{post.excerpt}</p>}
          {post.cover_image && (
            <div className="image-frame mt-10 mb-14">
              <img src={post.cover_image} alt={post.title} className="w-full h-[380px] object-cover grayscale-[25%] contrast-110" />
            </div>
          )}
          <div className="prose-gothic mt-10" data-testid="preview-body">
            <ReactMarkdown>{post.body || "*This entry holds only its title — for now.*"}</ReactMarkdown>
          </div>
        </article>
      </main>
    </div>
  );
}
